/**
 * @ngdoc directive
 * @name cbl.telepass.mf.directive:tlpsDocumenti
 * @restrict E
 * @description Componente per la gestione della parte documentale della pratica
 */
(function() {
  'use strict';
  var TlpsDocumentiCtrl = function(
    $http,
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    traslocoTelepassSrvc
  ) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.ndg;
    this.idProdotto;
    this.idPratica;

    // Questo componente viene usato sia nella parte di proposta che in quella di trasloco nel post vendita,
    // per poter utilizzare lo stesso componente con metodi e con dati differenti si va a contorllare in quale dei
    // due service sono presenti i dati.
    this.mainSrvc;

    this.fieldConfiguration = null;

    // Gestione Widget
    this.showSecondLevelKeyFl = false;
    this.onlyCurrent = false;
    this.readonlyVariazione = true;
    this.hideMenu = false;

    var self = this;

    /*
     * -------------------------------------
     *           PROMISE SERVIZI REST
     * -------------------------------------
     */

    this.datiValidi = function() {
      return true;
    };

    this.selectCurrentService = function() {
      if (!!self.propostaTelepassSrvc.datiPratica) {
        return self.propostaTelepassSrvc;
      }

      if (!!self.traslocoTelepassSrvc.datiPratica) {
        return self.traslocoTelepassSrvc;
      }

      return null;
    };

    /*
     * -------------------------------------
     *           METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;

      self.mainSrvc = self.selectCurrentService();

      self.mainSrvc.datiValidi = self.datiValidi;

      self.mainSrvc.spinner.showSpinner = false;

      self.intestatario = angular.copy(self.mainSrvc.datiCliente);
    };

    /**
     * Resta in ascolto del cambiamento sulla listaStatiDocumenti che contiene i documenti firmati
     */
    $scope.$watch(
        'listaStatiDocumenti',
        function(newValue, oldValue, $scope) {
          if (angular.isArray(newValue)) {
            if (newValue.length === 0) {
              self.propostaTelepassSrvc.documentiFirmati = true;
              self.traslocoTelepassSrvc.documentiFirmati = true;
            } else {
              self.propostaTelepassSrvc.documentiFirmati = !newValue.find(function(value) {
                return !value.stateValid;
              });
              self.traslocoTelepassSrvc.documentiFirmati = !newValue.find(function(value) {
                return !value.stateValid;
              });
            }
          }
        },
        true
    );

    self.init();
  };

  TlpsDocumentiCtrl.$inject = [
    '$http',
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsTraslocoTelepassSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDocumenti/tlpsDocumenti.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsDocumentiComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: TlpsDocumentiCtrl,
    controllerAs: 'documentiCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsDocumenti', TlpsDocumentiComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsDocumenti/tlpsDocumenti.cmpt.js
// module id = 31
// module chunks = 0